import { useState } from "react";
import { Link } from "react-router-dom";
import { Truck } from "@phosphor-icons/react";
import { Panel, Segmented, Th, Td, Empty, Tag } from "@/components/common";
import { api, qty, fmtDate, L } from "@/lib/api";
import { useLoad } from "@/lib/useLoad";

export default function PendingShipments() {
  const [kind, setKind] = useState("sale");
  const [rows] = useLoad(() => api.get("/pending-shipments").then((r) => r.data), []);
  if (!rows) return null;
  const list = rows.filter((r) => r.kind === kind);
  const sale = kind === "sale";
  const orders = new Set(list.map((r) => r.order_id)).size;

  return (
    <Panel title={sale ? "Sevk Bekleyen Ürünler" : "Teslim Alınacak Ürünler"} icon={Truck} accent="orange" testid="pending-shipments"
      right={<Segmented value={kind} onChange={setKind} prefix="pending-kind" options={[["sale", "Satış (Sevk)"], ["purchase", "Alış (Mal Kabul)"]]} />}>
      <div className="max-h-[360px] overflow-auto">
        <table className="w-full">
          <thead><tr><Th>Sipariş</Th><Th>Tarih</Th><Th>Cari</Th><Th>Ürün</Th><Th>Durum</Th><Th right>Sipariş</Th><Th right>{sale ? "Sevk Edilen" : "Teslim Alınan"}</Th><Th right>Kalan</Th>{sale && <Th right>Stok</Th>}</tr></thead>
          <tbody>
            {list.length === 0 && <Empty cols={sale ? 9 : 8} text={sale ? "Sevk bekleyen ürün yok" : "Teslim alınacak ürün yok"} />}
            {list.map((r) => (
              <tr key={r.key} className="even:bg-zinc-50 hover:bg-orange-50/60" data-testid={`pending-row-${r.order_no}`}>
                <Td><Link to={`/siparisler/${r.order_id}`} className="font-num text-xs font-semibold text-primary hover:underline">{r.order_no}</Link></Td>
                <Td className="font-num text-xs">{fmtDate(r.date)}</Td>
                <Td><Link to={`/cariler/${r.account_id}`} className="hover:text-primary">{r.account_name}</Link></Td>
                <Td className="font-medium">{r.name}</Td>
                <Td><Tag tone={r.status}>{L.status[r.status]}</Tag></Td>
                <Td right>{qty(r.ordered)}</Td>
                <Td right className="text-emerald-700">{qty(r.shipped)}</Td>
                <Td right className="font-bold text-orange-600" data-testid={`pending-remaining-${r.key}`}>{qty(r.remaining)} <span className="text-[11px] font-normal text-muted-foreground">{r.unit}</span></Td>
                {sale && <Td right>{r.stock < r.remaining ? <Tag tone="low">{qty(r.stock)} · Yetersiz</Tag> : qty(r.stock)}</Td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="border-t border-zinc-200 bg-zinc-50 px-5 py-2.5 text-xs text-muted-foreground" data-testid="pending-shipments-summary">
        {orders} sipariş · {list.length} ürün satırı bekliyor
      </div>
    </Panel>
  );
}
